import { render, staticRenderFns } from "./StorageDetailModal.vue?vue&type=template&id=185dec32&scoped=true"
import script from "./StorageDetailModal.vue?vue&type=script&lang=js"
export * from "./StorageDetailModal.vue?vue&type=script&lang=js"
import style0 from "./StorageDetailModal.vue?vue&type=style&index=0&id=185dec32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185dec32",
  null
  
)

export default component.exports